import React, { useEffect, useState } from "react";
import PasswordStrengthBar from "react-password-strength-bar";

// images
import EyeOn from "../../Assets/eye-on.svg";
import EyeOff from "../../Assets/eye-off.svg";

// -- redux
import { connect } from "react-redux";
import { UpdatePasswordActions, ResetPasswordActions } from "../../Redux/Actions/UpdatePassword";
import { logout } from "../../utils";
import { withRouter } from "react-router";
import Loader from "../Loader";

function CreatePassword(props) {
  const [show, setShow] = useState([false, false]);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [ConfPasswordError, setConfPasswordError] = useState("");
  const [SuccessMessage, setSuccessMessage] = useState("");

  const OnChange = (e) => {
    setPassword(e.target.value);
    let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/;
    if (!passwordRegex.test(e.target.value)) {
      setPasswordError("New Password must have atleast 1 lowercase, 1 uppercase, 1 special character, 1 numeric value");
    } else if (e.target.value.length < 8) {
      setPasswordError("New Password must be minimum 8 characters");
    } else if (e.target.value.length > 16) {
      setPasswordError("New Password can't have more than 16 characters");
    } else if (passwordRegex.test(e.target.value)) {
      setPasswordError("");
    }
  };

  const submit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setConfPasswordError("Password does not match");
    }
    if (password === confirmPassword && props.location.pathname === "/create-password") {
      setConfPasswordError("");
      const data = {
        email: props.location.email,
        password: password,
        temp_token: props.location.token,
        bankcode: props.location.bankcode,
      };
      props.UpdatePasswordActions(data);
    }
    if (password === confirmPassword && props.location.pathname === "/reset-password") {
      setConfPasswordError("");
      const data = {
        password: password,
        temp_token: props.location.search.split("=")[1],
      };

      props.ResetPasswordActions(data);
    }
  };

  useEffect(() => {
    if (props.data.error) {
      alert(JSON.stringify(props.data.data));
    } else {
      props.data && props.data.status === 200 && setSuccessMessage(props.data.message);
      props.data && props.data.status === 200 && logout();
    }
  }, [props.data]);

  const handleKeyDown = (e, type) => {
    if (type === "conf-password") {
      if (e.key === " " && confirmPassword.length === 0) {
        e.preventDefault();
      }
    } else {
      if (e.key === " " && password.length === 0) {
        e.preventDefault();
      }
    }
  };

  return (
    <>
      {props.loading && <Loader />}
      <form className="mt-4" onSubmit={(e) => submit(e)}>
        {SuccessMessage && <p className="text-success m-0 f-12">{SuccessMessage}</p>}
        <div className="mt-3 text-left">
          <label className="text-white w-100 position-relative" htmlFor="password">
            <p className="mb-0 f-12">New Password</p>
            <input id="password" type={show[0] ? "text" : "password"} placeholder="Your password" className={passwordError ? "form-input-danger form-input f-14 mt-1 pb-1 text-white" : "form-input f-14 mt-1 pb-1 text-white"} onChange={(e) => OnChange(e)} value={password} onKeyDown={handleKeyDown} />
            <img onClick={() => setShow([!show[0], show[1]])} className="InputIcon cursor-pointer" src={show[0] ? EyeOn : EyeOff} alt="EyeOn" />
          </label>
          <PasswordStrengthBar password={password} scoreWordStyle={{ display: "none" }} minLength={4} barColors={["#646464", "#FF3B30", "#f6b44d", "#00FF6A", "#00FF6A"]} />
        </div>
        {passwordError && <p className="f-12 mt-1 mb-0 text-danger text-left">{passwordError}</p>}

        <div className="mt-3 position-relative text-left">
          <label className="text-white w-100" htmlFor="newPassword">
            <p className="mb-0 f-12">Confirm New Password</p>
            <input id="newPassword" type={show[1] ? "text" : "password"} placeholder="Your password" className={ConfPasswordError ? "form-input-danger form-input f-14 mt-1 pb-1 text-white" : "form-input f-14 mt-1 pb-1 text-white"} onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} onKeyDown={(e) => handleKeyDown(e, "conf-password")} />
            <img onClick={() => setShow([show[0], !show[1]])} className="InputIcon cursor-pointer" src={show[1] ? EyeOn : EyeOff} alt="EyeOn" />
          </label>
        </div>
        {ConfPasswordError && <span className="f-12 mt-1 text-danger float-left">{ConfPasswordError}</span>}

        <button onClick={(e) => submit(e)} type="submit" className="form-button f-14 mt-4Center centerMargin" disabled={!(confirmPassword && password && !passwordError)}>
          Continue
        </button>
      </form>
    </>
  );
}

const mapStateToProps = ({ UpdatePasswordReducer }) => {
  const { loading, data } = UpdatePasswordReducer;
  return { loading, data };
};

const mapDispatchToProps = {
  UpdatePasswordActions,
  ResetPasswordActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreatePassword));
